import React, { useRef } from "react";
import Select from "react-select";
import "./multiselect-scrollbar.scss";

const MultiSelectField = ({
  className,
  placeholder,
  options,
  selectedValues,
  onSelect,
  onRemove,
  displayValue,
  label,
  error,
  required,
  section,
  isDisabled,
  setId,
  setName,
}) => {
  const prevSelectedRef = useRef(selectedValues || []);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: section ? "#272727" : "#2E3033",
      borderColor: section ? (isDisabled ? "#272727" : "#4B4B4B") : "#606264",
      color: "#fff",
      boxShadow: "none",
      borderRadius: "6px",
      minHeight: "40px",
      "&:hover": {
        borderColor: "#606264",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      paddingTop: "2px",
      paddingBottom: "2px",
    }),
    input: (base) => ({
      ...base,
      color: "#fff",
      margin: "0px",
      height: "auto",
      padding: "0px",
    }),
    placeholder: (base) => ({
      ...base,
      color: section ? "#a9a9a9" : "#999999",
      paddingLeft: "3px",
      margin: 0,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#0D0D0D",
      borderRadius: "4px",
      alignItem: "center",
      paddingRight: isDisabled ? "3px" : "0px",
    }),
    multiValueGeneric: (base) => ({
      ...base,
      fontSize: "14px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#fff",
      fontSize: "14px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#fff",
      backgroundColor: "#2E3033",
      padding: "0px",
      height: "14px",
      width: "14px",
      margin: "7px 4px",
      display: isDisabled ? "none" : "flex",
      alignItem: "center",
      ":hover": {
        color: "#fff",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#1e1e1e",
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#333" : "#1e1e1e",
      color: "#fff",
      cursor: "pointer",
      ":active": {
        backgroundColor: "#444",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: "#fff",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      display: isDisabled ? "none" : "flex",
    }),
  };

  const handleChange = (newSelected = []) => {
    const prevSelected = prevSelectedRef.current;
    prevSelectedRef.current = newSelected;
    if (section === "language") {
      setId(newSelected.code);
      setName(newSelected.name);
    }
    if (newSelected.length > prevSelected.length) {
      onSelect?.(newSelected);
    } else {
      onRemove?.(newSelected);
    }
  };
  function hoursToHHMM(value) {
    if (value == null || isNaN(value)) return "";

    const sign = value >= 0 ? "+" : "-";
    const totalMinutes = Math.round(Math.abs(value) * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  }
  // Determine the value key based on displayValue
  const getValueKey = () => {
    if (displayValue === "territoryName") {
      return "territoryId";
    }

    return "id";
  };
  function formatCityName(name) {
    return name.replace(/^.*\//, "").replace(/_/g, " ");
  }
  const getDisplayTimeZoneValue = (option) => {
    return `(GMT ${hoursToHHMM(option.gmtOffset)}) ${formatCityName(
      option.timezone
    )}`;
  };

  return (
    <div className={error ? "form-field hasError" : "form-field"}>
      {label && (
        <label>
          {label} {required && <i>*</i>}
        </label>
      )}
      <Select
        className={className}
        classNamePrefix="rs"
        placeholder={placeholder}
        options={options}
        value={selectedValues}
        onChange={handleChange}
        getOptionLabel={(option) =>
          displayValue === "timezone"
            ? getDisplayTimeZoneValue(option)
            : option[displayValue]
        } // Use dynamic display value
        getOptionValue={(option) => option[getValueKey()]} // Use dynamic value key
        isMulti={section === "language" ? false : true}
        styles={customStyles}
        isDisabled={isDisabled || false}
        menuPosition="auto"
        menuShouldScrollIntoView={false}
      />
      {error && <span className="field-error">{error}</span>}
    </div>
  );
};

export default MultiSelectField;
